// subscribePresenceOrder.js
'use strict';
import getMeData from '../selector/getMeData.js';
import * as MessageTypes from '../serviceWorker/AppMessageTypes.js';
import { sendMessageToSW } from '../serviceWorker/helpers.js';

/**
 * Subscribe presence order
 * @kind action
 * @param {string} {orderId} - order id.
 * @return {Promise} Action promise.
 */
const subscribePresenceOrder =
  ({ orderId }) =>
  async (dispatch, getState) => {
    const token = getMeData(getState(), 'token');
    if (!token || !orderId) {
      return dispatch({ type: '' });
    }
    return sendMessageToSW({
      type: MessageTypes.SUBSCRIBE_PRESENCE_ORDER_CHANNEL,
      payload: {
        orderId,
      },
    });
  };

export default subscribePresenceOrder;
